window.addEventListener('load', function(){
  let formSelector = "#newsletterForm";
  let elems = {
    'nlMail': {'required': true, 'default': null},
    'nlPrivacy': {'required': true, 'default': null},
    'nlOtpStat': {'required': false, 'default': null},
    'nlOtpProfiling': {'required': false, 'default': null},
  }

  contactForm = new FormController(formSelector, elems, document.querySelector("#subscribe"), window.contactDomain + localeForm+"/mail.mngr",
    {
      successPopupId: 'newsletterConfirmed',
      initCallback: function(){
        let elem = this.formNode.querySelector("#nlMail");
        elem.addEventListener('input', e => {
          if(elem.value == ""){
            this.formNode.querySelector(".privacyContentBlock").classList.remove("show");
          }
          else{
            this.formNode.querySelector(".privacyContentBlock").classList.add("show");
          }
        })
      }
    }
  );
  document.querySelector("#subscribeMobile").addEventListener("click", e=>{
    document.querySelector("#subscribe").click();
  })
  
  let nlMail = document.getElementById("nlMail");
  let privacyContentBlock = document.querySelector("#newsletterForm .privacyContentBlock");
  
  if(nlMail != null && privacyContentBlock != null){
    nlMail.addEventListener("focus", e=>{
      privacyContentBlock.classList.add("show");
    });
    document.getElementById("nlMail").addEventListener("blur", e=>{
      if(nlMail.value == ""){
        privacyContentBlock.classList.remove("show");
      }
    });
  }
})